import { render, staticRenderFns } from "./AutoOrder.vue?vue&type=template&id=47964dc7&scoped=true&"
import script from "./AutoOrder.vue?vue&type=script&lang=js&"
export * from "./AutoOrder.vue?vue&type=script&lang=js&"
import style0 from "./AutoOrder.vue?vue&type=style&index=0&id=47964dc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47964dc7",
  null
  
)

export default component.exports
import {QCardSection,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QCard,QBtn,QSeparator,QSelect,QInput,QTooltip,QPopupProxy,QTime,QToggle,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QCard,QBtn,QSeparator,QSelect,QInput,QTooltip,QPopupProxy,QTime,QToggle})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
